var _rect, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    role: "img",
    "aria-label": "Gaming mouse",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    rx: 10,
    fill: "#F3EEFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 34 C62 34 98 34 98 58 C98 82 80 90 80 90 C80 90 62 82 62 58 Z",
    fill: "#002454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34 V58",
    stroke: "#9e00ff",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 48,
    r: 4,
    fill: "#9e00ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68 78 L92 78",
    stroke: "#002454",
    strokeWidth: 4,
    strokeLinecap: "round",
    opacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMouse);
export default __webpack_public_path__ + "static/media/product-mouse.969f80a33b968e0181fdbd49d3e88c58.svg";
export { ForwardRef as ReactComponent };